<script>
import {GET_USER_BY_PHONE} from "@/core/services/store/user/users.module";
import {ADD_NEW_TUTOR, GET_DETAIL_TUTOR, UPDATE_TUTOR} from "@/core/services/store/tutor/tutor.module";
import WarningChangeTutor from "@/view/pages/tutor/human-management/WarningChangeTutor.vue";
import {nextTick} from "vue";

export default {
  name: "EditTutor",
  components: {WarningChangeTutor},
  props:{
    levels:{
      type: Array,
      default(){
        return []
      }
    },
    idTutor:{
      type: Number,
      default(){
      return 0
      }
    }
  },
  data() {
    return {
      okDisable: false,
      form: {
        staffSearch: '',
        level: '',
        zoomLink: '',
        meetLink: '',
        visible: true,
        fixedSchedule: true,
        user_id: null,
        zaloLink: '',
      },
      baseSchedule: [
        {
          name: 'Ca sáng',
          isFullWeek: false,
          days: [
            {day: 'thứ 2', isWork: false},
            {day: 'thứ 3', isWork: false},
            {day: 'thứ 4', isWork: false},
            {day: 'thứ 5', isWork: false},
            {day: 'thứ 6', isWork: false},
            {day: 'thứ 7', isWork: false},
            {day: 'Chủ nhật', isWork: false}
          ]
        },
        {
          name: 'Ca chiều',
          isFullWeek: false,
          days: [
            {day: 'thứ 2', isWork: false},
            {day: 'thứ 3', isWork: false},
            {day: 'thứ 4', isWork: false},
            {day: 'thứ 5', isWork: false},
            {day: 'thứ 6', isWork: false},
            {day: 'thứ 7', isWork: false},
            {day: 'Chủ nhật', isWork: false}
          ]
        },
        {
          name: 'Ca tối',
          isFullWeek: false,
          days: [
            {day: 'thứ 2', isWork: false},
            {day: 'thứ 3', isWork: false},
            {day: 'thứ 4', isWork: false},
            {day: 'thứ 5', isWork: false},
            {day: 'thứ 6', isWork: false},
            {day: 'thứ 7', isWork: false},
            {day: 'Chủ nhật', isWork: false}
          ]
        }
      ],
      fixedWorkSchedule: [],
      loading: false,
      listStaff: [],
      tutor: null,
      dataNeedChange: null,
      loadingAdd: false
    };
  },
  methods: {
    handleCheckAll(isFullWeek, days) {
      days.forEach((day) => {
        day.isWork = isFullWeek
      })
    },
    handleChooseDay(shift) {
      shift.isFullWeek = shift.days.every(day => day.isWork === true);
    },
    async findStaff(query) {
      try {
        this.loading = true
        let staffs = await this.$store.dispatch(GET_USER_BY_PHONE, {
          phone: query
        })
        this.listStaff = staffs.data
      } catch (e) {
        this.listStaff = []
      } finally {
        this.loading = false
      }
    },
    async editTutor() {
      let payload = {
        id: this.idTutor,
        user_id: this.form.user_id,
        type_id: 1,
        link_test: this.form.zoomLink,
        link_meet: this.form.meetLink,
        link_zalo: this.form.zaloLink,
        status: this.form.visible,
        is_fixed_schedule: this.form.fixedSchedule,
        academic_level_id: this.form.level,
        shifts: this.fixedWorkSchedule?.map((shift, shiftIndex) => {
          return {
            shift_id: shift?.shiftId,
            days: shift?.days?.map((day, dayIndex) => {
              return {
                day_of_week: dayIndex + 1,
                value: day?.isWork
              }
            })
          }
        })
      }
      this.loadingAdd = true
      try {
         await this.$store.dispatch(UPDATE_TUTOR,payload)
        this.$message({
          type:'success',
          showClose: true,
          message: 'Sửa gia sư thành công'
        });
        this.$bvModal.hide('edit-tutor')
        this.$emit('loadList')
      } catch (e) {
        if(e?.response?.data?.message?.error_code === 4001){
          let warningData = e?.response?.data?.message
          this.$message({
            showClose: true,
            message: `${warningData?.error_message??'Việc thay đổi lịch làm việc sẽ ảnh hưởng đến các task đã được gán. Vui lòng chọn admin thay thế cho các task bị ảnh hưởng.'}`,
            duration: 5000,
            type: 'warning'
          });
          this.dataNeedChange = warningData?.affected_tasks??[]
          nextTick(()=>{
            this.$bvModal.show('warning-assign')
          })

        }
      }finally {
        this.loadingAdd = false
      }
    },
    async handleWhenStart() {
      try {
        this.loading = true
        let data = await this.$store.dispatch(GET_DETAIL_TUTOR,this.idTutor)
        this.tutor = data.data
        this.loading = false
        this.form = {
          user_id: this.tutor?.user_id,
          staffSearch: this.tutor?.user_name,
          level: this.tutor?.academic_level_id,
          zoomLink: this.tutor?.link_test,
          meetLink:this.tutor?.link_meet,
          zaloLink: this.tutor?.link_zalo,
          visible: !!this.tutor?.status,
          fixedSchedule: !!this.tutor?.is_fixed_schedule,
        }
        this.fixedWorkSchedule = this.tutor?.shifts?.shifts.map((shift)=>{
          return {
            shiftId: shift.shift_id,
            name: shift?.name,
            isFullWeek: shift.days.every(day => day.value === true),
            days: shift?.days.map((day)=>{return {day:day.dayOfWeek,isWork:day.value}})
          }
        })
      }catch (e) {
        this.$message({
          showClose: true,
          message: 'Đã có lỗi xẩy ra. Vui lòng thử lại',
          type: 'error',
          duration: 6000
        });
        this.closeModal()
      }

    },
    closeModal(){
      this.$bvModal.hide('edit-tutor')
    }

  }
}
</script>

<template>
  <b-modal id="edit-tutor" title="Sửa nhân sự gia sư" hide-footer size="xl" @show="handleWhenStart">
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height:200px;">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <ValidationObserver v-else  v-slot="{ handleSubmit }" ref="form">
      <form class="form" autocomplete="off">
        <div class="container">
          <div class="row">
            <!-- Tìm nhân sự -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Tìm nhân sự<span class="text-danger">*</span></label>
                <ValidationProvider name="Nhân sự" rules="required" v-slot="{ errors,classes }" vid="staff_search_123">
                  <el-input :value="form.staffSearch" placeholder="Mã nhân sự, số điện thoại" clearable disabled/>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <!-- Trình độ -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Trình độ <span class="text-danger">*</span></label>
                <ValidationProvider name="Trình độ" rules="required" v-slot="{ errors,classes }" vid="level_123">
                  <el-select v-model="form.level" placeholder="Chọn trình độ" clearable filterable class="w-100">
                    <el-option v-for="item in levels" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <!-- Link Zoom -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Link Zoom <span class="text-danger">*</span></label>
                <ValidationProvider name="Link Zoom" rules="required" v-slot="{ errors,classes }" vid="zoom_link_2">
                  <el-input v-model="form.zoomLink" placeholder="Nhập link zoom" clearable/>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <!-- Link Meet -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Link Meet <span class="text-danger">*</span></label>
                <ValidationProvider name="Link Meet" rules="required" v-slot="{ errors,classes }" vid="meet_link_2">
                  <el-input v-model="form.meetLink" placeholder="Nhập link meet" clearable/>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Link Zalo <span class="text-danger">*</span></label>
                <ValidationProvider name="Link Meet" rules="required" v-slot="{ errors,classes }" vid="zalo_link_2">
                  <el-input v-model="form.zaloLink" placeholder="Nhập link zalo" clearable/>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <!-- Hiển thị -->
            <div class="col-md-12 row">
              <div class="col-md-6 mt-2">
                <el-switch v-model="form.visible" active-text="Hiển thị / Ẩn"/>
              </div>

              <!-- Lịch làm việc cố định -->
              <div class="col-md-6 mt-2">
                <el-switch v-model="form.fixedSchedule" active-text="Lịch làm việc cố định"/>
              </div>
            </div>

          </div>
          <div class="mt-5" v-if="form.fixedSchedule">
            <p>Lịch làm việc cố định</p>
            <div class="table-container">
              <table class="table table-bordered text-center align-middle">
                <thead class="thead-light">
                <tr>
                  <th>Ca làm việc</th>
                  <th>Tất cả</th>
                  <th>Thứ 2</th>
                  <th>Thứ 3</th>
                  <th>Thứ 4</th>
                  <th>Thứ 5</th>
                  <th>Thứ 6</th>
                  <th>Thứ 7</th>
                  <th>Chủ nhật</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="shift in fixedWorkSchedule" :key="shift.name">
                  <td>{{ shift.name }}</td>
                  <td>
                    <el-checkbox v-model="shift.isFullWeek"
                                 @change="handleCheckAll(shift.isFullWeek,shift.days)"></el-checkbox>
                  </td>
                  <td v-for="day in shift.days">
                    <el-checkbox v-model="day.isWork" @change="handleChooseDay(shift)"></el-checkbox>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-10">
            <button type="button" class="btn btn-secondary mr-4" @click="closeModal" :disabled="loadingAdd">Hủy bỏ</button>
            <button type="button" class="btn btn-primary" @click="editTutor()" :disabled="loadingAdd"> <i v-if="loadingAdd" class="el-icon-loading"></i>Xác nhận</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <WarningChangeTutor :dataNeedChange="dataNeedChange" :idTutor="idTutor"></WarningChangeTutor>
  </b-modal>
</template>

<style scoped>

</style>